import cartDuck from './duck'
import cartItemsDuck from './cart-items/duck'

// Retain the last confirmed bag while the existing remove + refresh completes.
// Never allow a second mutation to race the authoritative totals refresh.
export default function removeItem(options) {
  return async (dispatch, getState) => {
    if (getState().cart.isFetching || getState().cartData.removingItem) {
      return { skipped: true }
    }
    dispatch(cartItemsDuck.creators.setRemovingItem(options.productAttributeID))
    try {
      return await dispatch(
        cartDuck.creators.fetch({ ...options, type: 'DeleteFromCart' }),
      )
    } finally {
      dispatch(cartItemsDuck.creators.setRemovingItem(null))
    }
  }
}
